export const vendors = [
    {
        value: "seerat"
    },
    {
        value: "kainat"
    },
    {
        value: "akash"
    }
];

export const Approvals = [
    {
        value: "approved"
    },
    {
        value: "pending"
    },
];